import React, { useRef, useEffect } from "react";

const PartnersSection = () => {
  const scrollRef = useRef(null);
  let isDragging = false;
  let startX;
  let scrollLeft;

  // Handle mouse down for drag start
  const handleMouseDown = (e) => {
    isDragging = true;
    startX = e.pageX - scrollRef.current.offsetLeft;
    scrollLeft = scrollRef.current.scrollLeft;
    scrollRef.current.style.cursor = "grabbing";
  };

  // Handle mouse leave or up to stop dragging
  const handleMouseLeaveOrUp = () => {
    isDragging = false;
    scrollRef.current.style.cursor = "grab";
  };

  // Handle mouse move for dragging
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust drag speed
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // Prevent image drag
  useEffect(() => {
    const preventDefault = (e) => e.preventDefault();
    const images = scrollRef.current.querySelectorAll("img");
    images.forEach((img) => img.addEventListener("dragstart", preventDefault));
    return () => {
      images.forEach((img) => img.removeEventListener("dragstart", preventDefault));
    };
  }, []);

  return (
    <section className="section partners py-5 bg-white animate-fade-in-delay">
      <div className="container-fluid px-0">
        <div className="position-relative">
          <button
            className="partners-control start-0"
            onClick={() => {
              scrollRef.current.scrollBy({ left: -150, behavior: "smooth" });
            }}
          >
            ‹
          </button>
          <div
            className="partners-scroll d-flex"
            ref={scrollRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeaveOrUp}
            onMouseUp={handleMouseLeaveOrUp}
            onMouseMove={handleMouseMove}
          >
            {Array.from({ length: 10 }, (_, i) => {
              const index = (i + 1).toString().padStart(3, "0"); // Ensures 001 to 010
              return (
                <div className="partners-logo-wrapper" key={i}>
                  <img
                    src={`images/badges/${index}.png`}
                    alt={`Partner ${index}`}
                    className="partners-logo"
                    loading="lazy"
                  />
                </div>
              );
            })}
          </div>
          <button
            className="partners-control end-0"
            onClick={() => {
              scrollRef.current.scrollBy({ left: 150, behavior: "smooth" });
            }}
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;